<template>
    <v-dialog
      v-model="dialog"
      width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-col
            cols="12"
            lg="4"
            md="6"
          >
            <v-card
          class="ma-4">
          <v-row
            justify="space-around"
          >
        <v-card-title>ルートイレヴンは眠らない</v-card-title>
        <img src="../../assets/work/01logo-rin2022.png" alt="ルートイレヴンは眠らない" class="portfolio-img">
        <v-card-text>
          <p>ロゴ</p>
          </v-card-text>
        <v-btn
        class="mar-bottom"
          color="secondary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Details
        </v-btn>
      
          </v-row>
            </v-card>
          </v-col>
      </template>
      <v-card class="modal-title">
          <h2>ルートイレヴンは眠らない</h2>
          <img src="../../assets/work/02logo-rin2022.png" alt="ルートイレヴンは眠らない表紙" class="portfolio-img"><br>
          <img src="../../assets/work/03logo-rin2022.png" alt="ルートイレヴンは眠らない白黒" class="portfolio-img">
        <v-card-text class="modal-text">
          <h4>制作スキル</h4>
          <p>
          ・Illustrator<br>
          ・Photoshop</p>
          <h4>制作期間</h4>
          <p>ロゴ：7日程度</p>
           <h4>作品詳細リンク</h4>
           <p><a href="https://fujimi-trpg-online.jp/game/storyteller.html" target="_blank" rel="noopener noreferrer">富士見書房公式「ストリテラ オモテとウラのRPG」</a></p>
           <h4>作品紹介</h4>
           <p>「ストリテラ オモテとウラのRPG」に収録されている「ルートイレヴンは眠らない」のロゴを制作いたしました。<br>
               可読性を保ちつつ、イラストやストーリーの雰囲気を大切にし制作いたしました。<br>
               キーワードの「カーチェイス」や運び屋の「バディ」がどんなストーリーを紡ぐかイラストと共にワクワクするイメージで制作いたしました。<br>
           </p>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  export default {
    name:'SweetsOne',
    data: () => ({
      model: null,
      dialog: false,
    }),
  }
</script>
<style lang="scss">
@import '../../styles01/common/common.scss';
</style>